<template>
  <div class="ModelDialog">
    <van-popup v-model="visible" :close-on-click-overlay="false" @click-overlay="$emit('update:visible', false)">
      <div class="popupMain">
        <div class="popupBody">
          <p class="title">
            <slot name="title"></slot>
          </p>
          <p class="tip">
            <slot name="tip"></slot>
          </p>
        </div>
        <div class="popupBottom">
          <div class="cancel" @click="cancel">取消</div>
          <div class="confirm" @click="confirm">
            <slot name="confirmTxt">确定</slot>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  /**
   *确认弹出框组件
   */
  name: "ModelDialog",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    cancel() {
        this.$emit('update:visible', false)
    },
    confirm() {
         this.$emit('confirm')
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-popup {
  background: none;
}
.popupMain {
  width: 285px;
  height: 170px;
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #333333;

  .popupBody {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      width: 80%;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
    }

    .tip {
      height: 15px;
      line-height: 15px;
      font-size: 11px;
      color: #ff0000;
      margin-top: 5px;
    }
  }
  .popupBottom {
    height: 50px;
    display: flex;

    > div {
      flex: 1;
      height: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      background: #b2daff;
      color: #fff;
    }

    .confirm {
      background-color: #0286ff;
    }
  }
}
</style>